import { gql } from '@apollo/client';

export const getTopQuoteReplyQuery = gql`
  query getTopQuoteReplyQuery($articleId: ID!) {
    article(where: { id: $articleId }) {
      id
      sortedChildArticles(orderBy: { timepoints: "DESC" }, take: 1) {
        id
        body
      }
    }
  }
`;
